// 2026-10-07 表を横に動かす枠（snippets/jp-ecol-table.liquid）の動き：商品説明・ガイド本文で共通
// 枠より表が広い時だけ、案内の文字・右端の薄い影・キーボードで選べる状態にする。幅に収まる表は今までどおり。
(() => {
  const STEP = 80;
  document.querySelectorAll('[data-jd-table]').forEach((root) => {
    const scroller = root.querySelector('.jd-table__scroll');
    if (!scroller) return;

    const update = () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      const scrollable = max > 2;
      root.classList.toggle('is-scrollable', scrollable);
      root.classList.toggle('has-more', scrollable && scroller.scrollLeft < max - 2);
      root.classList.toggle('is-scrolled', scrollable && scroller.scrollLeft > 2);
      // 動かせない表は、キーボードで選ぶ対象・読み上げの区切りにしない
      if (scrollable) {
        scroller.setAttribute('tabindex', '0');
        scroller.setAttribute('role', 'region');
        scroller.setAttribute('aria-label', '表（横に動かせます）');
      } else {
        scroller.removeAttribute('tabindex');
        scroller.removeAttribute('role');
        scroller.removeAttribute('aria-label');
      }
    };

    scroller.addEventListener('scroll', update, { passive: true });
    scroller.addEventListener('keydown', (event) => {
      if (event.target !== scroller) return;
      const max = scroller.scrollWidth - scroller.clientWidth;
      const moves = { ArrowLeft: -STEP, ArrowRight: STEP, Home: -max, End: max };
      if (!(event.key in moves)) return;
      event.preventDefault();
      scroller.scrollBy({ left: moves[event.key], behavior: 'auto' });
    });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(scroller);
    else window.addEventListener('resize', update);
    update();
  });
})();
